import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserEgiApp } from '@/app/platform/platform-core/user/models/user-egi-app';
import { UserNavigationItem } from '@/app/platform/platform-core/user/models/user-navigation-item';
import {
  ACTIVE_APP_QUERIES,
  ActiveAppQueries
} from '@/app/platform/platform-core/user/queries/types';

@Injectable({
  providedIn: 'root'
})
/**
 * Contains the context of the current app
 */
export class PlatformAppContext {
  constructor(
    @Inject(ACTIVE_APP_QUERIES)
    private readonly activeAppQueries: ActiveAppQueries
  ) {}

  /**
   * The current EgiApp
   */
  readonly activeApp$: Observable<UserEgiApp | undefined> = this.activeAppQueries.activeApp$;

  /**
   * The current EgiApp
   */
  get activeApp(): UserEgiApp | undefined {
    return this.activeAppQueries.getActiveApp();
  }

  /**
   * The current NavigationItem
   */
  readonly activeNavigationItem$: Observable<UserNavigationItem | undefined> =
    this.activeAppQueries.activeNavigationItem$;

  /**
   * The current NavigationItem
   */
  get activeNavigationItem(): UserNavigationItem | undefined {
    return this.activeAppQueries.getActiveNavigationItem();
  }
}
